import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";
import { SYSTEM_ACCOUNT_TYPE } from "./systems.constants";

export function useSystemsBrowse() {
  return useAccountTypeBrowse({
    accountType: SYSTEM_ACCOUNT_TYPE,
  });
}
